import type { Messages } from './en.ts';

export const ja: Messages = {
  'nav.dashboard': 'ダッシュボード',
  'nav.stake': 'ステーク',
  'nav.bond': 'ボンド',
  'nav.swap': 'スワップ',
  'nav.liquidity': '流動性',
  'nav.referral': '紹介',
  'nav.docs': 'ドキュメント',
  'nav.admin': '管理',
  'nav.more': 'その他',
  'wallet.connect': 'ウォレット接続',
  'wallet.choose': 'ウォレットを選択',
  'wallet.disconnect': '切断',
  'wallet.copy': 'アドレスをコピー',
  'wallet.copied': 'コピーしました',
  'wallet.none': 'ウォレットが見つかりません。MetaMask、Trust Wallet、Binance Wallet、OKX Wallet などの拡張機能をインストールするか、ウォレットアプリでこのページを開いてください。',
  'wallet.walletconnect': 'WalletConnect（モバイルウォレット、Binance Wallet、Safe など 300 種類以上）',
  'wallet.openIn': '{wallet} で開く',
  'wallet.mobileHint': 'スマートフォンでは、ウォレットアプリ内でこのページを開くか、WalletConnect で任意のウォレットを接続してください。',
  'wallet.safety': '接続で共有されるのはアドレスのみです。すべての取引は署名前にウォレットに表示されます。',
  'network.wrong': 'ネットワークが違います',
  'network.switch': '{chain} に切り替え',
  'common.close': '閉じる',
  'common.max': '最大',
  'common.balance': '残高',
  'common.approve': '{token} を承認',
  'common.confirmInWallet': 'ウォレットで確認してください…',
  'common.pending': '承認待ち…',
  'common.done': '完了',
  'common.viewTx': '取引を表示',
  'common.connectFirst': '続行するにはウォレットを接続してください',
  'common.enterAmount': '数量を入力',
  'common.insufficient': '{token} の残高が不足しています',
  'common.loading': '読み込み中…',
  'common.notAdvice': '利率・ROI・APY は現在のパラメータから計算され、変動します。将来の収益を約束するものではありません。',
  'page.dashboard.title': 'ダッシュボード',
  'page.stake.title': 'ステーク',
  'page.bond.title': 'ボンド',
  'page.swap.title': 'スワップ',
  'page.liquidity.title': '流動性',
  'page.referral.title': '紹介',
  'page.docs.title': 'ドキュメント',
  'page.admin.title': '管理',
  'dash.eyebrow': 'プロトコル',
  'dash.title': '概要',
  'dash.price': 'SYN 価格',
  'dash.priceSub': '30分 TWAP · スポット {spot}',
  'dash.marketCap': '時価総額',
  'dash.treasury': 'トレジャリー（リスクフリー）',
  'dash.treasurySub': 'トレジャリー保有の USDT + BNB + LP',
  'dash.backing': '1 SYN あたりの裏付け',
  'dash.staked': 'ステーク率',
  'dash.stakedSub': '総供給量に対して',
  'dash.apySub': '12時間エポックあたり {rate}',
  'dash.index': 'sSYN インデックス',
  'dash.nextRebase': '次のリベース',
  'dash.runway': 'ランウェイ',
  'dash.runwayDays': '{n} 日',
  'dash.runwaySub': 'トレジャリー ÷ 1日の報酬価値',
  'dash.mcapVsBacking': '時価総額とトレジャリー裏付け',
  'dash.premium': '市場は SYN をトレジャリー裏付けの {x} 倍で評価しています。',
  'dash.yourPosition': 'あなたのポジション',
  'dash.wallet': 'ウォレット内',
  'dash.bonds': 'ボンド',
  'dash.bondCount': '{n} 件',
  'dash.referral': '請求可能な紹介報酬',
  'dash.how': '仕組み',
  'dash.how1': 'BNB、USDT、SYN-USDT LP でボンドを購入し、市場より安く SYN を取得します。7日後に全額ロック解除されます。',
  'dash.how2': 'SYN をロックなしから永久ロックまでの6つのプランでステークできます。どのプランも12時間ごとに複利で増えます。',
  'dash.how3': '報酬はエポックごとの上限内で新規発行されます。ボンドの支払いはトレジャリーを積み上げ、急落時に SYN を買い戻します。',
  'dash.how4': '友達を招待：直紹介のステーキング報酬の5%と、弱い側のレッグに対するランク別の報酬を、ステーク額の300%まで受け取れます。',
  'stake.eyebrow': 'ステーキング',
  'stake.title': 'SYN をステーク',
  'stake.amount': 'ステーク数量',
  'stake.fee': 'ステーク手数料（{pct}）',
  'stake.youGet': '受け取る量',
  'stake.unlocks': 'ロック解除',
  'stake.exitFee': 'アンステーク手数料',
  'stake.exitFeeNote': 'ステーキングから引き出すすべてに {pct}',
  'stake.principal': '元本として計上',
  'stake.cta': 'ステーク（{plan}）',
  'stake.positions': 'あなたのステーク',
  'stake.noLots': 'まだステークはありません。',
  'stake.lockedUntil': 'ロック中',
  'stake.withdrawn': '引き出し済み',
  'stake.withdraw': '引き出す',
  'stake.youReceiveNet': '{pct} の手数料後に {amount} SYN を受け取ります',
  'stake.projection': '試算',
  'stake.projectionNote': '現在のレートが期間中続いた場合。レートはエポックごとに変わり、報酬予算により下がることがあります。',
  'stake.after': '{period}後',
  'stake.d30': '30日',
  'stake.d90': '90日',
  'stake.d365': '1年',
  'stake.nothingPending': '未請求の報酬はまだありません',
  'common.approved': '{token} を承認しました',
  'bond.eyebrow': 'ボンド',
  'bond.title': '市場より安く SYN を購入',
  'bond.price': 'SYN 価格',
  'bond.treasury': 'トレジャリー',
  'bond.open': '開いている市場',
  'bond.openOf': '{m} 中 {n}',
  'bond.outstanding': '未払いの払出し',
  'bond.outstandingSub': '全ボンドでベスティング中の SYN',
  'bond.markets': 'ボンド市場',
  'bond.asset': '資産',
  'bond.bondPrice': 'ボンド価格',
  'bond.roi': 'ROI',
  'bond.discount': '割引',
  'bond.capacity': '残り容量',
  'bond.vesting': 'ベスティング',
  'bond.days7': '7日（一括解除）',
  'bond.closed': '停止中',
  'bond.select': 'ボンド',
  'bond.form': '{asset} でボンド',
  'bond.pay': '支払い',
  'bond.value': '評価額',
  'bond.receive': '受け取り',
  'bond.unlock': '全額解除',
  'bond.feeNote': '支払いの15%は手数料ウォレットへ、85%はトレジャリーへ。どちらも価格に含まれています。',
  'bond.slippage': '許容する価格変動',
  'bond.minReceive': '最低受取額',
  'bond.cta': 'ボンド',
  'bond.overMax': '1 回のボンドは最大 {amount} です',
  'bond.overCap': '今期の残りは {amount} のみです',
  'bond.soldOut': '今期は売り切れです',
  'bond.maxPer': '1 回あたりの上限',
  'bond.leftNow': '今期の残り',
  'bond.limitVal': '{payout} SYN ≈ {amount}',
  'bond.paused': 'ボンドは一時停止中です',
  'bond.pausedTitle': 'ボンドは一時停止中です。',
  'bond.pausedWhy': 'プールの価格（{spot}）が 30 分平均（{twap}）から {dev} 離れています。価格操作を防ぐため、ボンドは両者の差が {max} 以内のときだけ利用できます。平均が追いつくと自動的に再開します（通常 30 分以内。価格が戻ればそれより早く再開します）。ステーク・スワップ・請求はそのままご利用いただけます。',
  'bond.roiExplain': 'ROI は、ボンド解除時に現在の市場価格で得られる利益です。市場の販売量が増えると下がり、時間とともに回復します。',
  'bond.positions': 'あなたのボンド',
  'bond.chainId': 'コントラクト上のボンド ID {id}',
  'bond.none': 'ボンドはまだありません。',
  'bond.payout': '払出し',
  'bond.market': '市場',
  'bond.status': '状態',
  'bond.vestingStatus': 'ベスティング中',
  'bond.claimable': '請求可能',
  'bond.claimed': '請求済み',
  'bond.claimAll': '{n} 件を請求',
  'bond.claimStake': '{n} 件を請求してステーク',
  'bond.into': 'ステーク先',
  'bond.claimableTotal': '請求可能 {amount} SYN',
  'swap.eyebrow': 'PancakeSwap V2',
  'swap.title': 'スワップ',
  'swap.pay': '支払い',
  'swap.receive': '受け取り（見積り）',
  'swap.flip': '方向を切り替え',
  'swap.rate': 'レート',
  'swap.minReceived': '最低受取額',
  'swap.impact': '価格インパクト',
  'swap.route': 'ルート',
  'swap.fee': 'プール手数料',
  'swap.slippage': 'スリッページ許容',
  'swap.cta': 'スワップ',
  'swap.highImpact': '価格インパクトが大きい：現在の価格より {pct} 不利なレートになります。少ない数量をご検討ください。',
  'swap.noRoute': 'このペアのプールはありません',
  'swap.noTax': 'SYN に送金税はありません。プール手数料と価格インパクトのみです。',
  'swap.pool': 'SYN-USDT プール',
  'swap.reserves': 'リザーブ',
  'swap.tvl': 'プール価値',
  'liq.eyebrow': 'PancakeSwap V2',
  'liq.title': 'SYN-USDT 流動性',
  'liq.add': '追加',
  'liq.remove': '削除',
  'liq.first': 'プールの現在の比率で両方のトークンを預けます。持分に応じて LP トークンを受け取り、スワップ手数料がプールに入ります。',
  'liq.share': '追加後のシェア',
  'liq.slippage': '最大スリッページ',
  'liq.noLp': 'このプールの LP トークンはまだありません。先に流動性を追加してください。',
  'liq.lpOut': '受け取る LP トークン',
  'liq.ctaAdd': '流動性を追加',
  'liq.removeAmount': '削除する LP トークン',
  'liq.youGet': '受け取り',
  'liq.ctaRemove': '流動性を削除',
  'liq.position': 'あなたのポジション',
  'liq.lpBalance': 'LP トークン',
  'liq.poolShare': 'プールシェア',
  'liq.underlying': '内訳',
  'liq.bondIt': 'LP トークンは SYN-USDT LP 市場で割引ボンドに使えます。',
  'liq.goBond': 'ボンドへ',
  'liq.risk': '流動性提供にはインパーマネントロス、スリッページ、スマートコントラクトのリスクがあります。',
  'ref.eyebrow': 'バイナリーツリー',
  'ref.title': '紹介',
  'ref.rank': 'ランク',
  'ref.left': '左レッグ（有効）',
  'ref.right': '右レッグ（有効）',
  'ref.matched': 'マッチ（弱い側）',
  'ref.claimable': '請求可能',
  'ref.direct': '直紹介',
  'ref.directSub': 'そのステーキング報酬の {bps}',
  'ref.cap': '紹介上限',
  'ref.capUsed': '{cap} 中 {used} 使用',
  'ref.capNote': '紹介報酬と引き出した元本は、ピーク時の有効ステークの300%に計上されます。追加ステークで上限が上がります。',
  'ref.inviteTitle': '招待リンク',
  'ref.inviteAbout': '新メンバーは選んだ側に参加し、最初のステークでその側の最も外側の空き枠に配置されます。招待した全員から直紹介ボーナスを、弱い側のレッグからバイナリー報酬を得られます。',
  'ref.placeLeft': '左',
  'ref.placeRight': '右',
  'ref.copy': 'リンクをコピー',
  'ref.copied': 'コピーしました',
  'ref.yourCode': 'あなたの招待コード',
  'ref.codeNote': 'あなたのウォレット {address} に紐付いています。コードはメンバーにしか存在しないため、作り話のコードは使えません。',
  'ref.copyCode': 'コードをコピー',
  'ref.sponsorHint': '例: K7Q2M9XA または 0x…',
  'ref.lookingUp': '招待コードを確認しています…',
  'ref.codeUnknown': 'この招待コードのメンバーはいません',
  'ref.lookupFailed': '現在コードを確認できません。紹介者のアドレスを貼り付けてください',
  'ref.needStake': '招待リンクを得るには SYN をステーク（または紹介者に紐付け）してください。',
  'ref.bindTitle': '紹介者の下に参加',
  'ref.bindAbout': '参加は永久で、最初のステーク前に行う必要があります。行わない場合はプロジェクトの下に配置されます。ツリー内の位置は最初のステークで決まります。',
  'ref.sponsor': '招待コードまたは紹介者アドレス',
  'ref.side': 'サイド',
  'ref.sideHint': '招待した人があなたの2つのチームのどちらに入るかを選びます。バイナリー報酬は小さい方のチームに対して支払われ、ランクには両方のチームが必要です。両サイドを育てましょう。',
  'ref.sideHintJoin': '紹介者の2つのチームのどちらに入るかを選びます。リンクで選ばれていますが、紐付け前なら変更できます。',
  'join.invited': '{sponsor} さん（コード {code}、{side}チーム）から招待されています。今すぐそのチームに参加してください。ツリー内の位置は最初のステークで決まります。参加せずにステークすると、プロジェクトの既定の紹介者の下に永久に配置されます。',
  'join.cta': '紹介者のチームに参加',
  'join.left': '左',
  'join.right': '右',
  'join.none': 'まだ紹介チームに参加していません。このままステークすると、プロジェクトの既定の紹介者の下に永久に配置されます。招待を受けている場合は、先にその招待リンクを開いてください。',
  'ref.bindCta': '紹介者を紐付け',
  'ref.badAddress': '招待コードまたはウォレットアドレスを入力してください',
  'ref.sponsorUnknown': 'この紹介者はまだ参加していません',
  'ref.sponsorOk': '紹介者が見つかりました: {address}',
  'ref.bound': 'あなたの紹介者',
  'ref.placedUnder': '{parent} の {side} に配置',
  'ref.notPlacedYet': 'ツリー内の位置は最初のステークで決まります',
  'ref.teamTitle': 'あなたのチーム',
  'ref.teamPlaced': 'チーム内',
  'ref.teamPending': '参加済み・未ステーク',
  'ref.teamEmpty': 'まだあなたのリンクから参加した人はいません。',
  'ref.teamPendingNote': '最初のステークでチーム内の位置が決まります。',
  'ref.teamMember': 'メンバー',
  'ref.teamSide': '側',
  'ref.teamStake': 'アクティブなステーク',
  'ref.ladder': 'ランク',
  'ref.ladderNote': 'ランクには、両レッグに同時にステークされている額の合計と、各サイドにその少なくとも {pct} が必要です。一度達したランクは生涯有効です。',
  'ref.member': 'メンバー',
  'ref.bronze': 'ブロンズ',
  'ref.silver': 'シルバー',
  'ref.gold': 'ゴールド',
  'ref.diamond': 'ダイヤモンド',
  'ref.crown': 'クラウン',
  'ref.rate': 'バイナリー率',
  'ref.needs': '必要条件',
  'ref.total': '合計',
  'ref.weaker': '弱い側',
  'ref.reached': '達成',
  'ref.tree': 'あなたのツリー',
  'ref.treeAbout': 'メンバーをタップするとその下のツリーを表示します。',
  'ref.you': 'あなた',
  'ref.legendLeft': '左チーム',
  'ref.legendRight': '右チーム',
  'ref.openSlot': '空き枠',
  'ref.legendFlow': '有効なステークは上へ集計されます',
  'ref.back': '自分に戻る',
  'ref.own': '自身のステーク',
  'ref.claimTitle': '紹介報酬を請求',
  'ref.claimAbout': '30分平均価格で新規発行された SYN で支払われます。有効なステークが必要です。',
  'ref.approx': '≈ {amount} SYN',
  'ref.claimCta': '請求',
  'ref.notEligible': '紹介報酬の請求には SYN のステークが必要です',
  'docs.eyebrow': 'ガイド',
  'docs.title': 'Syntra の仕組み',
  'docs.bondH': 'ボンド',
  'docs.bondP': 'BNB、USDT、SYN-USDT LP で支払い、現在価格で支払額以上の価値の SYN を受け取ります（ROI）。払出しは購入からちょうど7日後に全額解除され、購入ごとに個別に進行します。支払いの15%は手数料ウォレットへ、85%はトレジャリーへ。',
  'docs.stakeH': 'ステーキング',
  'docs.stakeP': '6つのプランがあり、いずれも12時間ごとに複利で増えます。ロックなし（いつでも引き出し可能。SYN ↔ sSYN 変換と同じ）、30・90・180・365日ロック（ロック終了後は引き出し可能になり、ロックなしの利率で複利が続きます）、永久ロック（元本は引き出せませんが、報酬はいつでも引き出せます）。報酬は新規発行され、エポックごとの上限があります。',
  'docs.refH': '紹介',
  'docs.refP': '招待した全員のステーキング報酬の {direct} と、弱い側のレッグのステーキング報酬に対するランク別の率を得られます。紹介報酬と引き出した元本は、ピーク時の有効ステークの {cap} の上限に計上されます。獲得と請求にはステークが必要です。',
  'docs.treasuryH': 'トレジャリーと買い戻し',
  'docs.treasuryP': 'ボンドの支払いと手数料は、プロジェクトのマルチシグが管理するトレジャリーに積み上がります。30分平均価格が7日間の高値を大きく下回ると、トレジャリーは PancakeSwap で上限付きで SYN を買い戻し、焼却します。',
  'docs.feesH': '手数料',
  'docs.action': '操作',
  'docs.feeCol': '手数料',
  'docs.feeBond': 'ボンド',
  'docs.feeStake': 'ステーク入金',
  'docs.feeUnstake': 'アンステーク・引き出し・ステーキング報酬の請求',
  'docs.feeSwap': 'SYN のスワップ・送金',
  'docs.feeSwapV': '税 0%（プール手数料のみ）',
  'docs.ranksH': 'ランク',
  'docs.rankCol': 'ランク',
  'docs.threshold': 'チームボリューム',
  'docs.perSide': '各サイド',
  'docs.rateCol': 'バイナリー率',
  'docs.risksH': 'リスク',
  'docs.risk1': 'SYN の価格は下落する可能性があります。報酬は SYN で支払われるため、その価値も変動します。',
  'docs.risk2': '報酬のための新規発行は供給量を増やします。利率は調整可能で保証されません。',
  'docs.risk3': 'スマートコントラクトには不具合の可能性があります。失っても問題ない範囲でご利用ください。',
  'docs.risk4': 'ウォレットですべての取引（ネットワーク、トークン、承認先、数量）を確認してください。シードフレーズは絶対に共有しないでください。',
  'docs.risk5': '本サイトの内容は投資助言ではありません。暗号資産や紹介プログラムに関する現地の規制が適用される場合があります。',
  'docs.contractsH': 'コントラクト',
  'docs.contract': 'コントラクト',
  'docs.address': 'アドレス',
  'admin.eyebrow': 'ガバナンス',
  'admin.title': 'プロトコル管理',
  'admin.roleNote': '変更は {delay} のタイムロックを通ります。管理者ウォレットが予約し、待機時間の経過後に実行します。一時停止は即時です。',
  'admin.youProposer': 'このウォレットは管理者です。変更の予約・実行とコントラクトの一時停止ができます。',
  'admin.notProposer': 'このウォレットは管理者ではありません。変更を予約・実行するには、MetaMask（または他のウォレット）で管理者ウォレットを接続してください。',
  'admin.staking': 'ステーキング',
  'admin.bonds': 'ボンド',
  'admin.referral': '紹介',
  'admin.mint': '発行予算（12時間エポックあたり）',
  'admin.buyback': '買い戻し',
  'admin.oracle': 'オラクル',
  'admin.paused': '停止中',
  'admin.active': '稼働中',
  'admin.available': '現在利用可能',
  'admin.propose': '変更を準備',
  'admin.action': '変更内容',
  'admin.actRates': 'ステーキング利率',
  'admin.actMarket': 'ボンド市場',
  'admin.actBuyback': '買い戻し設定',
  'admin.actUnpause': 'モジュールの再開',
  'admin.market': '市場',
  'admin.enabled': '有効',
  'admin.roiMin': 'ROI 最小（%）',
  'admin.roiMax': 'ROI 最大（%）',
  'admin.capacity': '期間あたり容量（SYN）',
  'admin.trigger': '7日高値からの下落トリガー（%）',
  'admin.maxTrade': '1回あたり上限（USDT）',
  'admin.maxDay': '1日あたり上限（USDT）',
  'admin.slip': 'スリッページ（%）',
  'admin.cooldownH': 'クールダウン（時間）',
  'admin.burn': '買い戻した SYN を焼却',
  'admin.module': 'モジュール',
  'admin.target': '対象',
  'admin.calldata': 'コールデータ',
  'admin.schedule': 'タイムロックで予約',
  'admin.copyJson': 'Safe Transaction Builder 用 JSON をコピー',
  'admin.copied': 'コピーしました',
  'admin.queue': 'タイムロックの予約',
  'admin.noQueue': '予約された操作はありません。',
  'admin.op': '操作',
  'admin.eta': '実行可能時刻',
  'admin.state': '状態',
  'admin.waiting': '待機中',
  'admin.ready': '実行可能',
  'admin.done': '完了',
  'admin.cancelled': '取消',
  'admin.execute': '実行',
  'admin.emergency': '緊急停止',
  'admin.emergencyNote': '一時停止は新規入金・ボンド・紐付け・紹介報酬の請求を止めます。引き出しとボンドの請求は常に可能です。再開はタイムロック経由です。',
  'admin.pause': '{module} を停止',
  'admin.pauseSafeOnly': 'これらのコントラクトを一時停止できるのは管理者ウォレットだけです。このウォレットでは状態を確認できます。',
  'admin.wallets': '管理者ウォレット:',
  'admin.actAddAdmin': '管理者ウォレットを追加',
  'admin.actRemoveAdmin': '管理者ウォレットを削除',
  'admin.wallet': 'ウォレットアドレス',
  'admin.walletInvalid': 'ウォレットアドレス（0x に続く 40 文字）を入力してください。',
  'admin.walletAlready': 'このウォレットはすでに管理者です。',
  'admin.walletNotAdmin': 'このウォレットは管理者ではありません。',
  'admin.walletLast': '管理者ウォレットはこの 1 つだけです。先に別の管理者を追加してください。そうしないと誰も変更できなくなります。',
  'admin.addAdminNote': '実行後、このウォレットは MetaMask などどのウォレットからでも、変更の予約・実行とコントラクトの一時停止ができるようになります。',
  'admin.removeAdminNote': '実行後、このウォレットは予約・実行・一時停止ができなくなります。',
  'admin.moreCalls': '他 {n} 件',
  'admin.needAdmin': '管理者ウォレットが必要です',
  'dash.activity': '最近のアクティビティ',
  'dash.noActivity': 'アクティビティはまだありません。',
  'dash.activityNeedsIndexer': 'アクティビティ履歴にはインデクサーが必要です（VITE_INDEXER_URL を設定）。',
  'act.stake': 'ステーク',
  'act.bind': '紹介者に紐付け',
  'act.bond': 'ボンドを購入',
  'act.bond_claim': 'ボンドを請求',
  'act.referral_claim': '紹介報酬を請求',
  'page.dashboard.sub': 'ステーク。リベース。成長。',
  'page.stake.sub': '6つのプラン、すべて12時間ごとに複利。',
  'page.bond.sub': '市場より安く SYN を購入、7日後にロック解除。',
  'page.swap.sub': 'PancakeSwap で SYN・USDT・BNB を取引。',
  'page.liquidity.sub': 'SYN と USDT をペアにして LP をボンドに。',
  'page.referral.sub': 'バイナリーチームの両レッグを育てましょう。',
  'page.docs.sub': 'Syntra の仕組みをわかりやすく。',
  'page.admin.sub': 'パラメーター、タイムロック、緊急操作。',
  'side.active': '稼働中',
  'side.epoch': 'エポック',
  'side.endsIn': '終了まで',
  'social.soon': 'リンクは近日公開',
  'wallet.connected': '接続済み',
  'price.label': 'SYN 価格',
  'price.twap': '30分平均',
  'notes.title': 'お知らせ',
  'notes.nextRebase': 'エポック {n} のリベースまで',
  'notes.rate': 'エポックあたりの利率（ロックなし～永久）',
  'notes.empty': 'ウォレットのアクティビティはまだありません。',
  'dash2.balance': 'sSYN 残高',
  'dash2.staked': 'ステーク残高',
  'dash2.allStaked': '全ホルダーのステーク',
  'dash2.growth': 'リベース成長',
  'dash2.thisEpoch': '前エポック +{pct}',
  'dash2.nextEpoch': '次のリベース +{pct}',
  'dash2.apy': 'APY',
  'dash2.apyInfo': '永久ロックプランを現在の支払レート（通常はそのレート、報酬予算が不足すればそれ以下）で12時間ごとに複利運用した場合です。収益を約束するものではありません。',
  'dash2.currentApy': '永久ロック APY',
  'dash2.rateOfMax': 'エポックあたり {rate}（上限 {max}）',
  'dash2.binaryRate': 'バイナリー {rate}',
  'dash2.needTotal': 'チームのボリュームがあと {amount}',
  'dash2.needWeaker': '小さい方のレッグがあと {amount}',
  'dash2.stillNeeded': '残り：{needs}。',
  'dash2.reqMet': '両方の条件を満たしています。次のチームの動きで新しいランクが適用されます。',
  'dash2.topRank': '{rank} 到達・バイナリー {rate}',
  'dash2.rankConnect': 'ウォレットを接続すると、次の紹介ランクまでの進捗が表示されます。',
  'dash2.overview': 'リベース概要',
  'dash2.overviewInfo': '期間中のリベースによる 1 sSYN の成長。',
  'dash2.projectedNote': '現在のレートでの予測：リベース履歴はまだありません。',
  'dash2.epochN': 'エポック +{n}',
  'dash2.rebases': 'リベース回数',
  'dash2.inPeriod': 'この期間',
  'dash2.avgRebase': '平均リベース',
  'dash2.perEpoch': 'エポックあたり',
  'dash2.projection': '報酬予測',
  'dash2.projectionInfo': '現在のレートでのリベース収益。レートは変わる可能性があり、保証ではありません。',
  'dash2.days': '{n}日',
  'dash2.day': '{n}日目',
  'dash2.example': '1,000 SYN をロックなしで',
  'dash2.allocation': 'ステーキング配分',
  'dash2.allocationInfo': 'あなたの SYN：ステーク中、ウォレット内、預け入れを上回る複利報酬。',
  'dash2.allocationAllInfo': 'すべての SYN：ロックプラン、ロックなし、未ステーク。',
  'dash2.stakedShort': 'ステーク',
  'dash2.available': '利用可能',
  'dash2.rewards': '報酬',
  'dash2.locked': 'ロック',
  'dash2.unstaked': '未ステーク',
  'dash2.ofSupply': '供給量のステーク率',
  'dash2.stakeMore': 'SYN を追加ステーク',
  'dash2.period': '予測期間',
  'dash2.orbLabel': 'ステーク {staked} sSYN · 次のリベースまで {pct} 経過 · 供給の {share} がステーク済み · エポックあたりの報酬 {rate}',
  'dash2.rebasing': '12時間ごとにリベース',
  'dash2.nextRebase': '次のリベース',
  'dash2.index': 'sSYN インデックス',
  'dash2.nextUnlock': '次のロック解除',
  'dash2.allUnlocked': '解除済み',
  'dash2.noLocks': 'ロック中の入金なし',
  'dash2.stakedSupply': '供給量のステーク率',
  'dash2.perDay': '1日あたり',
  'dash2.atRate': '現在のレート',
  'dash2.periodYield': '期間利回り',
  'dash2.onStake': 'ステーク額に対して',
  'dash2.totalStaked': 'ステーク合計',
  'dash2.lockedPlusFlex': '全プランの sSYN',
  'dash2.stakedValue': 'ステーク評価額',
  'dash2.atTwap': '30分平均価格',
  'dash2.mintedLastN': '全ステーカーへの SYN・直近 {n} エポック',
  'dash2.mintedNextN': '全ステーカーへの SYN・現在のレートで次の {n} エポック',
  'stake.compounding': 'エポックごとに複利',
  'bond.insight': '{asset} マーケット',
  'bond.openNow': '受付中',
  'bond.marketPrice': '市場価格',
  'bond.capLeft': '今期の残り販売枠',
  'bond.roiBand': 'リングはこのマーケットの ROI 上限 {max} に対する割合です。ROI はボンドの販売と債務の減衰に応じて {min}〜{max} の間で変動します。',
  'swap.priceChart': 'SYN 価格',
  'swap.priceRange': '価格の期間',
  'swap.noHistory': '価格履歴はプールの取引に合わせて 1 時間ごとに蓄積されます。',
  'swap.noIndexer': '価格履歴を見るにはインデクサーを接続してください。',
  'swap.priceNote': 'SYN-USDT プールの終値です。取引のない時間は直前の価格を維持します。',
  'liq.ownership': 'プールの保有内訳',
  'liq.treasury': 'トレジャリー（プロトコル保有）',
  'liq.you': 'あなた',
  'liq.others': 'その他の保有者',
  'liq.yourShare': 'あなたのシェア',
  'liq.polShort': 'プロトコル保有',
  'liq.tvlSub': '両サイドをプール価格で評価',
  'liq.locked': 'ロック中（初期流動性）',
  'liq.lockedShort': 'ロック中',
  'liq.lockedUntil': 'プールの {pct} は初期流動性で、{date} までロックされています。その後は管理ウォレットにのみ渡ります。',
  'liq.lockContract': 'ロックのコントラクト',
  'ref.yourRank': 'あなたのランク',
  'ref.nextRate': '次: {rank} · {rate}',
  'ref.toNext': '次のランクまで',
  'ref.topRankShort': '最高ランク',
  'ref.legs': 'レッグ別アクティブ額',
  'ref.weakerShare': '弱い側のレッグが全体の {pct} を占めています。',
  'ref.rankConnect': 'ウォレットを接続すると、ランクとツリーの左右レッグを確認できます。',
  'ref.earnTitle': '報酬の仕組み',
  'ref.earnDirect': 'ダイレクトボーナス',
  'ref.earnDirectP': '招待したすべての人のステーキング報酬の {pct}。',
  'ref.earnBinary': 'バイナリー報酬',
  'ref.earnBinaryP': '弱い側のレッグの利回りに対し、ランクに応じた {min}〜{max} のレート。',
  'ref.earnCap': '報酬上限',
  'ref.earnCapP': '報酬と引き出した元本の合計は、最大アクティブステーク額の {pct} で上限に達します。',
  'testnet.pill': 'BSC テストネット',
  'testnet.text': 'テスト用の資金のみで、実際の価値はありません。ボタンを押すと、手数料用のテスト BNB と 1,000 テスト USDT が届きます。テスト BNB の追加:',
  'testnet.faucet': 'BNB Chain フォーセット',
  'testnet.mint': 'テスト BNB + 1,000 USDT を受け取る',
  'testnet.mintOnchain': 'テスト USDT を 1,000 受け取る',
  'testnet.sending': '送信中…',
  'testnet.sent': '手数料用のテスト BNB と 1,000 テスト USDT を送りました。',
  'testnet.sentUsdt': '1,000 テスト USDT を送りました（手数料用の BNB はすでにお持ちです）。',
  'testnet.sentNoBnb': '1,000 テスト USDT を送りました。現在フォーセットのテスト BNB が不足しているため、BNB Chain フォーセットをご利用ください。',
  'testnet.cooldown': 'このウォレットはすでにテスト資金を受け取っています。{time}後に再度お試しください。',
  'testnet.limit': 'フォーセットは現在上限に達しています。{time}後に再度お試しください。',
  'testnet.failed': '現在フォーセットから送信できません。1 分ほどしてから再度お試しください。',
  'plan.0': 'ロックなし',
  'plan.1': '30日ロック',
  'plan.2': '90日ロック',
  'plan.3': '180日ロック',
  'plan.4': '365日ロック',
  'plan.5': '永久ロック',
  'plan.apy': 'APY {pct}',
  'plan.lockNone': 'いつでも引き出し可能',
  'plan.lockDays': '{days}日間ロック',
  'plan.featured': '最高利率',
  'plan.featuredNoFees': '最高利率 · 手数料ゼロ',
  'plan.lockForever': '元本は永久にロック',
  'plan.fees': '手数料 入金 {in} · 出金 {out}',
  'plan.noFees': '入金・出金とも手数料なし',
  'stake.feeNone': 'ステーク手数料',
  'stake.noFee': 'なし',
  'stake.exitFeePermanentFree': '元本は引き出し不可。報酬は手数料なしで引き出せます',
  'stake.youReceiveNoFee': '手数料なしで {amount} SYN を受け取ります',
  'plan.anytime': 'いつでも',
  'plan.never': 'なし（報酬はいつでも）',
  'plan.aboutLocked': '{days}日間ロックし、より高い利率で12時間ごとに複利運用します。ロック終了後は引き出し可能になり、ロックなしの利率で複利が続きます。',
  'plan.aboutPermanent': '最も高い利率です。元本は永久にロックされ、それを上回る報酬は12時間ごとに複利で増え、いつでも引き出せます。',
  'plan.about0': 'ロックなしの sSYN です。12時間ごとに複利で増え、いつでも引き出せます。スワップページの SYN ↔ sSYN 変換と同じです。',
  'stake.choose': 'プランを選択',
  'stake.form': 'ステーク · {plan}',
  'stake.claimRewards': '報酬を受け取る',
  'stake.noRewardsYet': 'まだ報酬はありません',
  'stake.lockEnded': 'ロック終了',
  'stake.endedRate': 'ロックなしの利率で複利運用中',
  'stake.projectionSwitch': '{days}日間のロック後はロックなしの利率で計算しています。現在の利率による試算で、収益を約束するものではありません。',
  'stake.exitFeePermanent': '元本は引き出し不可。報酬の引き出しに {pct}',
  'convert.flip': '向きを反転：{to} → {from}',
  'convert.title': 'SYN ↔ sSYN 変換',
  'convert.from': '変換する量（{token}）',
  'convert.to': '受け取る量（{token}）',
  'convert.rate': 'レート',
  'convert.rateValue': '1 : 1（{pct} の税を差し引き）',
  'convert.tax': '変換税（{pct}）',
  'convert.earns': 'sSYN の利回り',
  'convert.earnsValue': 'APR {apr} · APY {apy}（12時間ごとに複利）',
  'convert.about': 'sSYN はロックなしでステークされた SYN です。12時間ごとに増え、いつでも SYN に戻せます。税はトレジャリーに送られ、プールは使いません。',
  'convert.ctaIn': 'sSYN に変換',
  'convert.ctaOut': 'SYN に変換',
  'swap.mode': 'モード',
  'swap.nativeCoin': 'ネイティブコイン',
  'swap.modeSwap': 'PancakeSwap',
  'dash.apyPermanent': 'APY · 永久ロック',
  'dash.apyNoLock': 'APY · ロックなし',
  'dash.stakedAll': 'ステーク中（sSYN・全プラン）',
  'dash2.noLockApy': 'ロックなし {apy}',
  'dash2.noLock': 'ロックなし',
  'dash2.lockedPlans': '30・90・180・365日／永久プランの sSYN',
  'dash2.anytime': 'sSYN、いつでも引き出し可能',
  'docs.feePlans': 'ロックなし {noLock} · 30/90/180/365日ロック {locked} · 永久 {perm}',
  'admin.actFees': 'ステーキング手数料',
  'admin.planApr': '{plan}：APR（%）',
  'admin.feeNoLockIn': 'ロックなし：入金手数料（%）',
  'admin.feeNoLockOut': 'ロックなし：出金手数料（%）',
  'admin.feeLockedIn': 'ロックプラン：入金手数料（%）',
  'admin.feeLockedOut': 'ロックプラン：出金手数料（%）',
  'admin.feePermanentIn': '永久ロック：入金手数料（%）',
  'admin.feePermanentOut': '永久ロック：報酬の出金手数料（%）',
  'act.withdraw': '引き出し',
  'act.claim_rewards': '報酬を受け取り',
  'stake.unlocksIn': 'ロック解除まで',
  'stake.permanentNote': '元本は永久にロック · 報酬はいつでも',
  'stake.endedOn': '{date} にロック終了',
  'err.ZeroAmount': '0 より大きい金額を入力してください。',
  'err.RebaseBacklog': '直近 {n} エポック分の報酬がまだ支払われていないため、新しいステークはその処理後になります。下の「追いつく」を押すか、キーパーの処理を待ってから、もう一度お試しください。',
  'err.LotLocked': 'このポジションは {date} までロックされています。それ以降に引き出せます。',
  'err.LotEmpty': 'このポジションはすでに全額引き出されています。',
  'err.InsufficientStake': 'このポジションの保有額を超えています。引き出せるのは {available} SYN です。金額を減らすか「最大」を押してください。',
  'err.PermanentPrincipal': '永久ステークの元本は引き出せません。引き出せるのは報酬のみで、現在 {available} SYN です。それ以下の金額を入力してください。',
  'err.UnknownPlan': 'そのプランは存在しません。ページを再読み込みして、プランを選び直してください。',
  'err.NothingToClaim': 'まだ請求できる報酬はありません。紹介報酬はチームがステークしている間、12 時間ごとに積み上がります。',
  'err.NotEligible': '先に SYN をステークしてください。紹介報酬は、有効なステークがある間だけ支払われます。',
  'err.AlreadyBound': 'このウォレットはすでにチームに所属しています。紹介者は変更できません。',
  'err.SponsorNotBound': 'その紹介者はまだ参加していないため、その下には誰も参加できません。先に参加してもらってください。',
  'err.SelfReferral': '自分自身を紹介者にはできません。',
  'err.PlacementTooDeep': 'チームのその側は今は長すぎて配置できません。反対側から参加するか、紹介者にラインの修復を依頼してください。',
  'err.MarketClosed': 'このボンド市場は現在閉じています。別の市場を選ぶか、後でもう一度お試しください。',
  'err.UnknownMarket': 'そのボンド市場は存在しません。ページを再読み込みしてください。',
  'err.CapacityExceeded': 'この市場で今期に残っているのは {left} SYN ですが、このボンドは {payout} SYN になります。金額を減らすか、次の期間までお待ちください。',
  'err.MaxPayoutExceeded': '1 回のボンドで購入できるのは最大 {max} SYN ですが、これは {payout} SYN になります。金額を減らすか、分けて購入してください。',
  'err.SlippageExceeded': '確認中に価格が動きました。このボンドの支払いは {payout} SYN で、承諾した {min} SYN を下回ります。見積もりを更新して、もう一度お試しください。',
  'err.ValueMismatch': '送信された BNB が入力した金額と一致しません。ページを再読み込みして、もう一度お試しください。',
  'err.NotOwner': 'このボンドは別のウォレットのものです。',
  'err.AlreadyClaimed': 'このボンドはすでに請求済みです。',
  'err.StillVesting': 'このボンドは購入から 7 日後の {date} にロック解除されます。その時にお戻りください。',
  'err.PriceDeviation': 'ボンドは現在一時停止中です。プール価格（${spot}）が 30 分平均（${twap}）から {dev}% 離れています。価格操作を防ぐため、ボンドは両者の差が {max}% 以内のときだけ開きます。平均が追いつけば自動的に再開します（通常 30 分以内）。',
  'err.OracleNotReady': '価格オラクルは最初の 30 分の履歴を集めている最中です。しばらくしてからもう一度お試しください。',
  'err.StalePrice': '価格フィードが {age} 更新されていないため、この資産を今は安全に評価できません。フィードが更新され次第再開します。他の資産には影響ありません。',
  'err.InvalidPrice': '価格フィードが無効な値を返しました。しばらくしてからもう一度お試しいただくか、別の資産をお使いください。',
  'err.StablecoinDepeg': 'USDT が安全な範囲外の ${price} で取引されているため、戻るまで価格評価を停止しています。失われるものはありません。後でもう一度お試しください。',
  'err.UnsupportedAsset': 'その資産はここでは評価できません。',
  'err.MinterBudgetExceeded': '今エポックの報酬予算を使い切りました（残り {available} SYN）。12 時間ごとに補充されます。次のエポックでお試しください。',
  'err.GlobalBudgetExceeded': 'プロトコル全体の今エポックの報酬予算を使い切りました（残り {available} SYN）。12 時間ごとに補充されます。次のエポックでお試しください。',
  'err.MinterDisabled': 'このコントラクトの発行は現在停止されています。失われるものはありません。後でもう一度お試しください。',
  'err.EnforcedPause': 'この操作はプロトコルの管理者によって一時停止されています。引き出しと請求は引き続き可能で、新規の預け入れは再開後に行えます。',
  'err.AccessControlUnauthorizedAccount': 'このウォレットには、その操作に必要な権限がありません。',
  'err.TimelockUnexpectedOperationState': 'タイムロックが拒否しました。変更がまだ実行可能になっていないか、すでに実行済みか、取り消されています。キューを確認してください。',
  'err.TimelockUnauthorizedCaller': '変更の予約・実行ができるのは管理者ウォレットだけです。',
  'err.ERC20InsufficientBalance': 'トークンが不足しています。必要 {needed}、ウォレット残高 {have} です。',
  'err.ERC20InsufficientAllowance': 'この金額はまだコントラクトに承認されていません。先に承認してから、もう一度お試しください。',
  'err.NonTransferable': 'sSYN は送金できません。これはステーキング残高です。代わりにステークページから引き出してください。',
  'err.StillLocked': '初期流動性は {date} までロックされています。',
  'err.CooldownActive': 'バイバックは {date} までクールダウン中です。',
  'err.group.setting': 'コントラクトがその設定を拒否しました（{name}）。値を確認して、もう一度お試しください。',
  'err.group.timelock': 'タイムロックが拒否しました（{name}）。キューと待機時間を確認して、もう一度お試しください。',
  'err.group.token': 'トークンの送金に失敗しました（{name}）。金額と残高を確認して、もう一度お試しください。',
  'err.group.internal': 'コントラクトが呼び出しを拒否しました（{name}）。ページを再読み込みしてもう一度お試しください。繰り返す場合はチームにお知らせください。',
  'err.group.lock': '流動性ロックが拒否しました（{name}）。変更できるのは管理ウォレットだけで、期限は延長のみです。',
  'err.group.buyback': 'バイバックが拒否しました（{name}）。トリガー、クールダウン、1 日の上限の範囲内でのみ実行されます。',
  'err.group.upgrade': 'アップグレードが拒否されました（{name}）。実装アドレスと、それが UUPS コントラクトであることを確認してください。',
  'err.group.signature': '署名が拒否されました（{name}）。トークンを所有するウォレットでもう一度署名してください。',
  'err.unknown': 'コントラクトがリクエストを拒否しました（{name}）。ページを再読み込みして、もう一度お試しください。',
  'err.noGas': 'ネットワーク手数料を支払う BNB がウォレットに足りません。少量の BNB を追加して、もう一度お試しください。',
  'err.walletGeneric': 'ウォレットがリクエストを完了できませんでした。ロックを解除して、もう一度お試しください。',
  'err.wallet.4001': 'ウォレットでリクエストを拒否しました。',
  'err.wallet.4100': 'ウォレットがまだこのサイトを許可していません。ロックを解除して、もう一度お試しください。',
  'err.wallet.4200': 'お使いのウォレットはこのリクエストに対応していません。',
  'err.wallet.4900': 'ウォレットがネットワークから切断されています。確認して、もう一度お試しください。',
  'err.wallet.4901': 'ウォレットがこのネットワークに接続されていません。',
  'err.wallet.4902': 'ウォレットに BNB Smart Chain を追加してから、もう一度お試しください。',
  'err.wallet.-32002': 'ウォレットに処理待ちのリクエストがあります。先にウォレットを開いて承認するか閉じてください。',
  'err.wallet.-32603': 'ウォレットが内部エラーを報告しました。ロックを解除し、ページを再読み込みして、もう一度お試しください。',
  'epoch.behindTitle': '直近 {n} エポック分の報酬が支払い待ちです。',
  'epoch.behindBody': '処理が終わると、ステークと SYN → sSYN の変換が再開します。誰でも実行でき、かかるのはネットワーク手数料だけです。',
  'epoch.catchUp': '追いつく',
  'epoch.progress': '{total} エポック中 {done} 処理済み…',
  'epoch.caughtUp': 'すべてのエポックが支払われました。再びステークできます。',
  'common.fee': 'ネットワーク手数料 ≈ {amount} BNB',
  'docs.refCode': '招待コードはウォレットアドレスから生成される 8 文字です。万一 2 つのウォレットが同じコードになった場合、先に参加したウォレットがそのコードを保持し、もう一方はウォレットアドレスで招待します。',
  'news.title': '最新の更新',
  'news.fee': 'すべての操作ボタンの下に、確認前にネットワーク手数料が表示されるようになりました。このパネルには変更内容を掲載します。',
  'news.catchUp': '報酬エポックが未処理のときは、すべてのページのバーから「追いつく」を実行できます。また、すべてのエラーが何が起きたかと次に何をすべきかを表示します。',
  'news.ranksLock': 'ランクは同時にステーキング中の両レッグで数えるようになり、ロック契約がプロジェクトの SYN-USDT 流動性を 12 か月間保持します。',
  'news.joinFirst': '招待されたウォレットは、最初のステークの前に招待者のチームへの参加を求められます。言語メニューに旗、コミュニティリンク、そして任意の管理ウォレットで使える管理ページ。',
  'news.emblems': 'ダッシュボードにランクのエンブレムと次のランクまでのステップ、スワップにトークンメニューと切り替えボタン、3D のネットワーク・ツリー・ステーキング表示。',
  'news.plans': '6 つのステーキングプラン:ロックなし、30・90・180・365 日ロック、そして手数料なしのパーマネント。招待リンクに 8 文字のコード。',
  'news.staking': 'SYN と sSYN、SYN ↔ sSYN 変換を含む複利プラン、ワンタッチのフォーセット、すべてのコントラクトのソースを BscScan で検証済み。',
  'news.live': 'Syntra ブランドで BSC テストネットに公開。英語・日本語・韓国語に対応。',
  'plan.upTo': '最大',
  'plan.paying': '現在 {pct}（報酬予算による）',
  'dash2.budget': '報酬予算',
  'dash2.budgetUsed': '1 エポックあたり {cap} SYN のうち {used} SYN を使用',
  'dash2.budgetCapped': '予算が不足しています。今エポックは各プランがレートの {pct} を支払います。',
  'dash2.rateNote': '現在のレートに基づきます。報酬予算により下がることがあります。',
  'docs.budgetP': '各プランの APR は上限です。報酬は 1 エポックあたり {cap} SYN の予算から支払われ、全プランの必要額がそれを超えると、各プランはレートの同じ割合を支払います。そのためプールが大きくなるほど支払レートは下がります。現在、全プランで 1 エポックあたり {wanted} SYN が必要です。',
  'err.FeeBelowRate': '拒否されました。引き出し可能なプランでは、入出の手数料の合計が 1 エポック分のレートを下回ってはいけません（プラン {plan}：手数料 {fee} に対しレート {rate}/エポック）。',
  'news.rates': 'プランのレートは「最大」表示になりました。報酬予算が不足するとカードに現在の支払レートが表示され、ダッシュボードに予算メーターが加わりました。',
  'bond.reopensIn': '約 {time} 後、次に平均価格が動く時点で再開します。価格が戻ればそれより早く再開します。',
  'price.moving': '価格変動中：プール価格は平均から {dev} 離れています。',
  'price.movingRules': 'ここでは何も停止しません。ステークは 2 つの価格のうち低い方で計上され、紹介報酬の請求は高い方で支払われます。ボンドは両者が一致するまで待機します。',
  'news.price': '価格が急変してもステーキングと紹介報酬の請求は停止しません。ステークは平均価格と現在価格の低い方で計上され、請求は高い方で支払われます。ボンドのバナーには再開時刻が表示され、ステークと紹介ページに「価格変動中」の表示が加わりました。',
  'gov.c.staking': 'ステーキング',
  'gov.c.bonds': 'ボンド',
  'gov.c.referral': '紹介',
  'gov.c.buyback': '買い戻し',
  'gov.c.registry': 'ミント登録',
  'gov.c.timelock': 'タイムロック',
  'gov.c.treasury': 'トレジャリー',
  'gov.c.oracle': '価格オラクル',
  'gov.c.lpLock': '流動性ロック',
  'gov.c.unknown': 'コントラクト',
  'gov.r.proposer': '管理者（提案）',
  'gov.r.executor': '管理者（実行）',
  'gov.r.canceller': '拒否権（キャンセル）',
  'gov.r.pauser': '一時停止',
  'gov.r.admin': 'オーナー',
  'gov.r.treasurer': 'トレジャラー',
  'gov.r.keeper': 'キーパー',
  'gov.r.staking': 'ステーキング',
  'gov.r.stakeFor': '代理ステーク',
  'gov.r.other': '不明な',
  'gov.rates': 'ステーキングのレートが {aprs} APR に変わります（ロックなし・30・90・180・365 日・パーマネント）。',
  'gov.fees': 'ステーキング手数料が変わります：入金 {ins}、出金 {outs}。手数料ウォレット {recipient}。',
  'gov.maxRate': 'ステーキングの最大レートが 1 エポックあたり {pct} に変わります。',
  'gov.referralWiring': 'ステーキングが紹介コントラクト {address} に接続されます。',
  'gov.market': 'ボンド市場 {id}：{state}、ROI {min}–{max}、1 期間あたり容量 {cap} SYN。',
  'gov.marketNew': '新しいボンド市場：{state}、ROI {min}–{max}、1 期間あたり容量 {cap} SYN。',
  'gov.open': '公開',
  'gov.closed': '停止',
  'gov.buyback': '買い戻し設定：7 日高値から {trigger} 下で発動、1 回 {perTrade} USDT・1 日 {perDay} USDT まで、スリッページ {slip}、クールダウン {cooldown}、購入した SYN は{bought}。',
  'gov.burned': 'バーン',
  'gov.kept': 'トレジャリーに保管',
  'gov.minter': '{contract} のミント予算：1 エポックあたり {cap} SYN、バースト {n} エポック、{state}。',
  'gov.enabled': '有効',
  'gov.disabled': '無効',
  'gov.globalCap': '全体のミント予算：1 エポックあたり {cap} SYN、バースト {n} エポック。',
  'gov.referralRates': '紹介レート：直接 {direct}、ランク {ranks}、各サイド最低 {minSide}。',
  'gov.maxDepth': '紹介ボリュームが {n} 階層まで上がります。',
  'gov.capMultiplier': '紹介上限：最高アクティブステークの {pct}。',
  'gov.pause': '{contract} が一時停止されます。',
  'gov.unpause': '{contract} が再開されます。',
  'gov.upgrade': '{contract} コントラクトが実装 {impl} にアップグレードされます。',
  'gov.roleGrant': '{account} が {contract} の{role}ロールを得ます。',
  'gov.roleRevoke': '{account} が {contract} の{role}ロールを失います。',
  'gov.delay': 'タイムロックの遅延が {time} に変わります。',
  'gov.treasury': 'トレジャリー {fn}：{args}。',
  'gov.unknown': '{contract} への呼び出し {selector}。',
  'docs.upcomingH': '予定されている変更',
  'docs.upcomingNote': 'プロトコルのすべての変更は 48 時間のタイムロックを通ります。管理ウォレットが予約し、遅延の間ここに表示され、実行されるまで拒否権ウォレットがキャンセルできます。',
  'docs.upcomingNone': '予定されている変更はありません。',
  'docs.upcomingAt': '{date} から実行可能',
  'docs.upcomingReady': '今すぐ実行可能',
  'docs.upcomingAfter': '操作 {id} の後',
  'notes.change': '予定された変更',
  'notes.changeDone': '実行された変更',
  'admin.actAddVeto': '拒否権ウォレットを追加',
  'admin.actRemoveVeto': '拒否権ウォレットを削除',
  'admin.vetoNote': '拒否権ウォレットは予定された変更をキャンセルすることしかできません。プロトコルを操作しないハードウェアウォレットに保管してください。48 時間の間に不正な変更を止められる唯一の鍵です。',
  'admin.removeVetoNote': '実行後、このウォレットは予定された変更をキャンセルできなくなります。',
  'admin.vetoAlready': 'このウォレットはすでに拒否権を持っています。',
  'admin.vetoNotVeto': 'このウォレットは拒否権を持っていません。',
  'admin.vetoWallets': '拒否権ウォレット：',
  'admin.noVeto': '拒否権ウォレットがまだありません。盗まれた鍵で予約された不正な変更を止められるのは管理ウォレットだけです。キャンセル権だけを持つコールドウォレットを追加してください。',
  'admin.youCanceller': 'このウォレットは拒否権を持っています。下のキューで予定された変更をキャンセルできます。',
  'admin.actUpgrade': 'コントラクトをアップグレード',
  'admin.proxy': 'コントラクト',
  'admin.implementation': '新しい実装アドレス',
  'admin.implInvalid': '実装アドレスを入力してください（0x に続く 40 文字）。',
  'admin.implChecking': '実装を確認中…',
  'admin.implNotUups': 'このアドレスは UUPS 実装ではありません（proxiableUUID の確認に失敗）。',
  'admin.implOk': 'UUPS 実装です。予約の前に検証済みソースを確認してください。',
  'admin.implSource': 'BscScan のソース',
  'admin.upgradeNote': '実行後、プロキシはストレージをそのままに新しい実装で動作します。先にフォークでリハーサルしてください（npm run contracts:rehearsal）。',
  'admin.cancel': 'キャンセル',
  'admin.cancelNote': 'キャンセルすると操作は完全に削除されます。後で再度予約できます。',
  'news.rates2': 'ステーキングの新しいレート：365 日ロックは APR 250%、パーマネントは APR 365% になります。変更は 48 時間のタイムロックを経て反映され、それまでは「予定されている変更」に表示されます。',
  'news.gov': '予定されたすべての変更が、このページの「予定されている変更」とベルに、平易な言葉と実行時刻つきで表示されます。管理者はキャンセルしかできない拒否権ウォレットを追加し、管理ページからコントラクトのアップグレードを予約できます。',
};
